









































import { Component, Prop, Vue } from 'vue-property-decorator';
import Screen from '@/models/Screen';
import ScreenService from '@/services/ScreenService';

@Component
export default class ScreenEdit extends Vue {
    @Prop() public id!: number;
    @Prop() public customerid!: number;

    private Model: Screen = new Screen();
    private PageTitle: string = '';
    private Validated: boolean = false;

    private async created() {
        this.PageTitle = `${this.id === 0 ? 'New' : 'Edit'} Screen`;
        this.Model.CustomerId = this.customerid;
        if (this.id > 0) {
            this.LoadScreen(this.id);
        }
    }

    private PropertyState(propertyName: string) {
        if (!this.Validated) {
            return null;
        } else {
            const statusObj = this.Model.PropertyState(propertyName);
            if (statusObj) {
                return statusObj.Status;
            } else {
                return null;
            }
        }
    }

    private PropertyMessage(propertyName: string) {
        if (!this.Validated) {
            return '';
        } else {
            const statusObj = this.Model.PropertyState(propertyName);
            if (statusObj) {
                return statusObj.Message;
            } else {
                return null;
            }
        }
    }

    private async LoadScreen(id: number) {
        const screenService = new ScreenService();
        const response = await screenService.LoadScreen(id);
        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to load the information`);
        } else {
            if (response.Data != null) {
                this.Model = response.Data;
            }
        }
    }

    private async SaveForm() {
        const screenService = new ScreenService();

        let response: any;
        if (this.id === 0) {
            response = await screenService.AddScreen(this.Model);
        } else {
            response = await screenService.UpdateScreen(this.Model);
        }

        if (response.Error === true) {
            this.$bvModal.msgBoxOk(`There was an error while trying to save the information`);
        } else {
            this.$emit('changessaved', this.id > 0);
            this.$emit('editcancelled');
        }
    }

    private CancelSave() {
        this.$emit('editcancelled');
    }
}
